import { getCsrfValue } from "../../../../api/ApiHelper";

import { resolveApiUrl } from "../../../../utils/url/urlResolver";

export const editAddress = (data: {}, id: string): Promise<any> => {
  const apiUrl = resolveApiUrl(`/ship/to/address/${id}`);
  return fetch(apiUrl, {
    body: JSON.stringify(data),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "PUT",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });
};
